import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWallet, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { formatCurrency, getCurrencySymbol, getRate } from '../utils/currencyUtils';
import PortfolioCard from "../components/PortfolioCard";

function Stock() {
  localStorage.clear();
  const { user } = useUser();
  const [stock, setStock] = useState([]);
  const [stockList, setStockList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [stockTotal, setStockTotal] = useState(0);
    
  useEffect(() => {
    fetch(`/stock_list.txt`)
    .then((res) => res.json())
    .then((data) => {
    const stockList = Object.values(data);
    const updatedData = stockList.map((stock, index) => ({
        id: index + 1,
        logo: `https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`,
        name: stock.name,
        type: 'stock',
        symbol: stock.symbol,
        price: Number(stock.price.toFixed(2)),
        amount: 0,
    }));
    setStock(updatedData);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchmyStockes1: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setStockList(data.mystocks);
      }
    })
    .catch(err => {
        console.error('Error fetching stakes!')
    })
  }, [user]);
  useEffect(() => {
    if (!stock.length) return;
    const getTotalAmount = (list) => {
      return list.reduce((sum, item) => sum + Number(item.amount || 0), 0);
    };
    const totalAmount = getTotalAmount(stockList);
    const merged = [
      ...stock
    ];
    const sorted = merged.sort((a, b) => {
      if (b.amount > 0 && a.amount === 0) return 1;
      if (a.amount > 0 && b.amount === 0) return -1;
      return a.name.localeCompare(b.name);
    });
    setStock(sorted);
    setStockTotal(totalAmount);
  }, [stock, stockList]);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };

  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
      const r = await getRate(currencyCode);
      if (isMounted) setRate(r);
    };
    fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);

  const filteredStock = stock.filter(filteredAsset => 
    Object.values(filteredAsset).some(value => 
        value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  )
  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Stock" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Stock" icon={<FontAwesomeIcon icon={faWallet} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>   
            <div className="row">
              <div className="col-12">
                <PortfolioCard totalBal={stockTotal}/>
              </div>
              <div className="col-12">
                <div className="mycard mt-2" style={{minHeight: '85vh'}}>
                    <h4 className="fw-bold text-center">All Stocks</h4>
                    <p className="text-center" style={{fontSize: '14px'}}>Full list of all stocks, ETFs & ADRs available on Optiumledger.</p>
                    <div className="d-flex align-items-center form-control justify-content-between me-2 searchcon">
                        <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} style={{fontSize: '16px'}} />
                        <input 
                        type="text" 
                        placeholder="Search for stocks" 
                        className="searchinput"
                        value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <div className="mt-2 row">
                      {filteredStock.map((stocklist) => {
                        return (
                          <>
                            <div className="col-lg-4">
                              <a href={`/stocklist?symbol=${encodeURIComponent(stocklist.symbol)}`} className="d-flex align-items-center justify-content-between my-2" style={{textDecoration: 'none',color:'inherit'}}>
                                  <div className="d-flex align-items">
                                      <div className="overflow-hidden d-flex align-items-center justify-content-center rounded-circle" style={{width:'25px',height:'25px'}}>
                                        <img src={stocklist.logo} alt={stocklist.name} style={{width: '100%'}} />
                                      </div>
                                      <div className="ms-2">
                                        <h6 className="mb-0 fw-bold" style={{fontSize: '14px'}}>{stocklist.name} ({stocklist.symbol})</h6>
                                        <p className="text-secondary mb-0 fw-bold" style={{fontSize: '12px'}}>Balance:</p>
                                      </div> 
                                  </div>
                                  <div className="text-end">
                                    <p className="mb-0 fw-bold text-success" style={{fontSize: '13px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(stocklist.price * rate)}</p>
                                    <p className="mb-0 fw-bold" style={{fontSize: '13px'}}>{formatCurrency(stocklist.amount)} {stocklist.symbol}</p>
                                  </div>
                              </a>
                              <hr className="my-0" style={{opacity:'0.05'}}/>
                            </div>
                          </>
                        )
                      })}
                    </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Stock